import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import SimpleValue from 'react-select-simple-value'
import { brandsService } from '../../_services/brands.service'

export const Select = ({ options, value, ...props }) => (
  <SimpleValue options={options} value={value}>
    {simpleProps => <ReactSelect {...props} {...simpleProps} isMulti={true} />}
  </SimpleValue>
);

class BrandsMultiSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      defaultValue: '',
      data: [],
      selectedValue: [],
    };
  }

  componentDidMount() {
    this.getData();
  }

  // getData() {
  // console.log(this.props.data);
  // let data = this.props.data;
  // if (data) {
  //   this.setState({ data: this.props.data.map(elm => ({ "label": elm.name, "value": elm.id })), loading: false, isSubmitting: false });
  // }
  // };

  // componentWillReceiveProps(nextProps) {
  //   // console.log(nextProps);
  //   // if (nextProps && nextProps.categoryId && nextProps.categoryId !== this.state.categoryId) {
  //   //   this.setState({ categoryId: nextProps.categoryId, selectedValue: [] }, () => {
  //   //     this.getData();
  //   //   })
  //   // }
  //   if (nextProps && nextProps.data) {
  //     this.setState({ data: nextProps.data.map(elm => ({ "label": elm.name, "value": elm.id })), loading: false, isSubmitting: false });
  //   }
  // }

  getData() {
    this.setState({ loading: true })
    brandsService.getAll(this.props.brandType)
      .then((res) => {
        let data = res.data.map(elm => ({ "label": elm.name, "value": elm.id }))
        this.setState({ data: data, loading: false, isSubmitting: false });
      }).catch((error) => {
        this.setState({ loading: false })
        // console.log(error)
      });
  };

  handleChange = e => {
    console.log(e);
    let selectedValues = e ? e.map(el => (el.value)) : [];
    // this.setState({ selectedValue: selectedValues }, () => {
    this.props.onChange(selectedValues);
    // })
  }

  render() {
    const customStyles = {
      option: (provided, state) => ({
        ...provided,

      }),
      container: (provided) => ({
        ...provided,
        width: '100%',
      }),
      control: (provided) => ({
        // none of react-select's styles are passed to <Control />
        ...provided,
        background: '#f6f6f6',
        borderRadius: 20,
        height: 40,
        boxShadow: 'none',
        border: '1px solid #e1e1e1',
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),
      multiValue: (styles, { data }) => {
        return {
          ...styles,
          backgroundColor: '#6F64F8',
          borderRadius: 25,
          color: '#fff',
          padding: '2px 10px 2px 5px'
        };
      },
      multiValueLabel: (styles, { data }) => ({
        ...styles,
        color: '#fff',
      }),
      multiValueRemove: (styles, { data }) => ({
        ...styles,
        color: data.color,
        ':hover': {
          backgroundColor: data.color,
          color: 'white',
        },
      }),

    }
    const { loading, data, selectedValue } = this.state;
    const { disabled, className, isClearable, isMulti, value } = this.props;

    return (
      <ReactSelect
        value={data && value && data.filter(el => value.includes(el.value))}
        // SimpleValue={true}
        isClearable={isClearable}
        isMulti={true}
        isDisabled={disabled}
        placeholder=""
        styles={customStyles}
        options={data && data}
        onChange={this.handleChange}
        className={className ? className : "select"}
        isLoading={loading}
        noOptionsMessage={() => "نتیجه ای یافت نشد"}
        loadingMessage={() => "در حال بارگزاری"}
        closeMenuOnSelect={false}
      />
    );
  }
}
export default BrandsMultiSelect;
